
import React, {useEffect, useState} from "react"
import { RoundWhitePlain, WhitePlain } from "../generic/GenericButton";


export const HoverButton2 = ({ step, type, handleNext, className='',rounded='rounded-full', onClick=undefined, text='Suivant', ...rest}:any) => {
    return <>
        {
            rounded=== 'rounded-full' ?
            <RoundWhitePlain
                text={text}
                isButton={true}
                className={"px-[1.6rem] py-[.6rem] " + className}
                key={(new Date()).getSeconds()}
                type={(([1, 5, 6].includes(step) && type === 'enterprise') || type === 'freelance') ?  'submit' : !['enterprise', 'freelance'].includes(type)?type: 'button'}
                onClick={!([1, 5, 6].includes(step)) && type !== 'freelance' ? handleNext : onClick}
                {...(step && { form: `form-step${step}` })} 
                {...rest}
            />
            :
            <WhitePlain
                text={text}
                isButton={true}
                className={"px-[1.6rem] py-[.6rem] " + className}

                key={(new Date()).getSeconds()}
                type={(([1, 5, 6].includes(step) && type === 'enterprise') || type === 'freelance') ?  'submit' : !['enterprise', 'freelance'].includes(type)?type: 'button'}
                onClick={!([1, 5, 6].includes(step)) && type !== 'freelance' ? handleNext : onClick}
                {...((step !== undefined || step !==null) && { form: `form-step${step}` })} 
                {...rest}
            />
        }
        {/* <div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            key={(new Date()).getSeconds()}
            className={`relative inline-block p-[.1rem] ${rounded} bg-gradient-to-r from-[#805ad5] via-[#d53f8c] to-[#ed8936]`}
        >
            <button
                key={(new Date()).getSeconds()}
                type={(([1, 5, 6].includes(step) && type === 'enterprise') || type === 'freelance') ? 'submit' : 'button'}
                onClick={!([1, 5, 6].includes(step)) && type !== 'freelance' ? handleNext : onClick}
                form={`form-step${step}`}
                className={`w-full h-full px-6 font-bold ${rounded} hover:bg-[#F4F4F5] py-2 ${className}`}
            >
                <div className={`${hover ? 'bg-clip-text bg-gradient-to-r from-[#805ad5] via-[#d53f8c] to-[#ed8936] text-transparent ' : 'text-white'}`}>
                    {text}
                </div>
            </button>
        </div> */}
    </>;
    
  }